// src/utils/scheduleSettings.js

export const VOLUNTEERS_MIN = 1;
export const VOLUNTEERS_MAX = 8;
export const EXTRA_VOLUNTEERS_MAX = 2;

export function clampSlotCount(count, globalCount) {
  const upper = globalCount + EXTRA_VOLUNTEERS_MAX;
  if (count > upper) return upper;
  if (count < 1) return 1;
  return count;
}

export const DEFAULTS = Object.freeze({
  volunteersPerShift: 2,
  allowBackToBack: false,
});

const STORAGE_KEYS = Object.freeze({
  volunteersPerShift: 'volunteersPerShift',
  allowBackToBack: 'allowBackToBack',
});

export { STORAGE_KEYS };

function parseVolunteersPerShift(raw) {
  if (raw === null || raw === undefined) return DEFAULTS.volunteersPerShift;
  const n = parseInt(raw, 10);
  if (!Number.isInteger(n) || n < VOLUNTEERS_MIN || n > VOLUNTEERS_MAX) {
    return DEFAULTS.volunteersPerShift;
  }
  return n;
}

function parseAllowBackToBack(raw) {
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return DEFAULTS.allowBackToBack;
}

export function loadSettings() {
  let volunteersPerShift = DEFAULTS.volunteersPerShift;
  let allowBackToBack = DEFAULTS.allowBackToBack;

  try {
    volunteersPerShift = parseVolunteersPerShift(
      localStorage.getItem(STORAGE_KEYS.volunteersPerShift)
    );
    allowBackToBack = parseAllowBackToBack(
      localStorage.getItem(STORAGE_KEYS.allowBackToBack)
    );
  } catch (e) {
    // localStorage unavailable (private mode, SSR, etc.) — return defaults
  }

  return { volunteersPerShift, allowBackToBack };
}

export function saveSettings({ volunteersPerShift, allowBackToBack }) {
  try {
    localStorage.setItem(
      STORAGE_KEYS.volunteersPerShift,
      String(volunteersPerShift)
    );
    localStorage.setItem(
      STORAGE_KEYS.allowBackToBack,
      String(allowBackToBack)
    );
  } catch (e) {
    // localStorage unavailable — silently no-op (state still updates in-memory)
  }
}

export function resetSettings() {
  try {
    localStorage.removeItem(STORAGE_KEYS.volunteersPerShift);
    localStorage.removeItem(STORAGE_KEYS.allowBackToBack);
  } catch (e) {
    // silently no-op
  }
}

export function isAtDefaults({ volunteersPerShift, allowBackToBack }) {
  return (
    volunteersPerShift === DEFAULTS.volunteersPerShift &&
    allowBackToBack === DEFAULTS.allowBackToBack
  );
}
